import { Box } from "@mui/material";
import { useState } from "react";
import { v2 } from "../ui/v2Tokens";
import V2Dialog from "../ui/V2Dialog";
import { PrimaryButton, TextButton } from "../ui/primitives";

type Props = {
  open: boolean;
  onClose: () => void;
  defaultName: string;
  itemCount: number;
  onSave: (name: string) => void;
};

const SaveMealAsTemplateDialog = ({ open, onClose, defaultName, itemCount, onSave }: Props) => {
  const [name, setName] = useState(defaultName);

  return (
    <V2Dialog
      open={open}
      onClose={onClose}
      title="שמור כארוחה שמורה"
      subtitle="הארוחה תהיה זמינה לכל המאמנים בחברה"
      maxWidth="420px"
      actions={
        <>
          <TextButton onClick={onClose}>ביטול</TextButton>
          <PrimaryButton disabled={!name.trim() || itemCount === 0} onClick={() => onSave(name.trim())}>
            שמור ארוחה
          </PrimaryButton>
        </>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Box
          component="input"
          type="text"
          aria-label="שם הארוחה השמורה"
          placeholder="שם הארוחה השמורה"
          value={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
          sx={{
            height: "38px",
            padding: "0 10px",
            borderRadius: v2.rSm,
            border: `1.5px solid ${v2.line}`,
            fontSize: "13px",
            fontFamily: "inherit",
            color: v2.ink,
            outline: "none",
            "&:focus": { borderColor: v2.brand },
          }}
        />
        <Box sx={{ fontSize: "12px", color: itemCount === 0 ? v2.over : v2.ink2 }}>
          {itemCount === 0 ? "אין פריטים בארוחה — הוסף מזון לפני השמירה." : `${itemCount} פריטים יישמרו.`}
        </Box>
      </Box>
    </V2Dialog>
  );
};

export default SaveMealAsTemplateDialog;
